import { ChefHat, ClipboardList, Package } from "lucide-react"

import { SectionSidebarLayout } from "./SectionSidebarLayout"

export function KitchenSectionLayout() {
  return (
    <SectionSidebarLayout
      navId="kitchen"
      navItems={[
        { icon: ChefHat, label: "Today", to: "/kitchen/today" },
        { icon: ClipboardList, label: "Prep sheet", to: "/kitchen/prep" },
        { icon: Package, label: "Packing", to: "/kitchen/packing" },
      ]}
    />
  )
}
